import { Tab as HeadlessTab } from "@headlessui/react";
import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";

const tabVariants = cva(
    "flex cursor-pointer items-center font-semibold text-nowrap text-neutral-400 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-black data-hover:bg-black/5 data-selected:text-darkgreen-500",
    {
        variants: {
            variant: {
                default:
                    "border-b-2 border-transparent data-selected:border-darkgreen-500",
                pill: "rounded-full data-selected:bg-black/5",
            },
            size: {
                default: "-mb-0.5 gap-2 px-3 pt-2 pb-1.5 text-sm/4",
                sm: "gap-1 px-2.5 py-1 text-sm/4",
                lg: "gap-3 px-5 py-3 text-lg/6",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
);

export const Tab = ({ variant, size, className, children }) => {
    return (
        <HeadlessTab
            className={cn(
                tabVariants({
                    variant,
                    size,
                    className,
                }),
            )}
        >
            {children}
        </HeadlessTab>
    );
};
